import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCircleExclamation } from "@fortawesome/pro-light-svg-icons";
import Box from "@ternary/api-lib/ui-lib/components/Box";
import Button from "@ternary/api-lib/ui-lib/components/Button";
import Flex from "@ternary/api-lib/ui-lib/components/Flex";
import Icon from "@ternary/api-lib/ui-lib/components/Icon";
import Text from "@ternary/api-lib/ui-lib/components/Text";
import React from "react";

type LayoutAlertProps = {
  action?: string | JSX.Element;
  icon?: IconDefinition;
  message: string | JSX.Element;
  title?: string | JSX.Element;
  onActionClick?: () => void;
};

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "transparent",
  color: theme.primary_color_background,
  padding: `4px 12px`,

  "& span": {
    fontWeight: `${theme.fontWeight_semiBold} !important`,
  },

  "&:hover": {
    backgroundColor: "transparent",
  },
}));

// TODO: Make this component more flexible, configurable and reusable when Design System is in place
function LayoutAlert({
  action,
  icon = faCircleExclamation,
  message,
  title,
  onActionClick,
}: LayoutAlertProps): JSX.Element {
  const theme = useTheme();

  // TODO: Use theme colors when Design System is in place
  const backgroundColor = "#FFFAEB";
  const iconColor = "#DC6803";
  const textColor = "#535862";
  const titleColor = "#414651";

  return (
    <Box
      backgroundColor={backgroundColor}
      padding={`${theme.space_md} ${theme.space_lg}`}
    >
      <Flex
        alignItems="center"
        flex={1}
        gap={theme.space_lg}
        justifyContent="space-between"
      >
        <Icon color={iconColor} icon={icon} size="lg" />
        <Flex direction="column" gap={"2px"}>
          <Text
            color={`${titleColor} !important`}
            fontWeight={theme.fontWeight_semiBold}
          >
            {title}
          </Text>
          <Text color={`${textColor} !important`}>{message}</Text>
        </Flex>
        {action && (
          <Box>
            <StyledButton size="tiny" onClick={onActionClick}>
              {action}
            </StyledButton>
          </Box>
        )}
      </Flex>
    </Box>
  );
}

export default LayoutAlert;
